const TOGGLE_SIZES = ["small", "large"];

export default TOGGLE_SIZES;
